import { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';

const getCurrentDomain = (): string => {
  return typeof window !== 'undefined' ? window.location.origin : '';
};

export const trackFeatureAppReady = (trackingService: TrackingServiceV2) => {
  if (trackingService) {
    trackingService.track({
      event: {
        eventInfo: {
          eventAction: 'feature_app_ready',
          eventName: 'technical data - feature app ready',
        },
        attributes: {
          componentName: 'technical-data',
          label: '',
          targetURL: '',
          clickID: '',
          elementName: '',
          value: '',
          pos: '',
        },
      },
      componentUpdate: {
        attributes: {
          implementer: 2,
          version: __FEATURE_APP_VERSION__,
        },
        componentinfo: {
          componentID: __FEATURE_APP_NAME__,
        },
      },
    });
  }
};

export const registerImpressionTracking = (trackingService: TrackingServiceV2, ref: any) => {
  if (trackingService) {
    if (ref !== null && ref?.current) {
      trackingService?.registerImpressionTracking(ref?.current, () => {
        return {
          event: {
            eventInfo: {
              eventAction: 'impression',
              eventName: 'technical data - impression',
            },
            attributes: {
              componentName: 'technical-data',
              label: '',
              targetURL: '',
              clickID: '',
              elementName: '',
              value: '',
              pos: '',
            },
          },
        };
      });
    }
  }
};

export const trackDrawerClick = (
  trackingService: TrackingServiceV2,
  isOpen: boolean,
  label: string
) => {
  if (trackingService) {
    trackingService.track({
      event: {
        eventInfo: {
          eventAction: 'navigation',
          eventName: isOpen
            ? 'technical data - drawer close click'
            : 'technical data - drawer open click',
        },
        attributes: {
          componentName: 'technical-data',
          label,
          targetURL: '',
          clickID: '',
          elementName: 'icon',
          value: '',
          pos: '',
        },
      },
    });
  }
};

export const trackOwnersManualClick = (
  trackingService: TrackingServiceV2,
  label: string,
  targetURL: string
) => {
  if (trackingService) {
    trackingService.track({
      event: {
        eventInfo: {
          eventAction: targetURL.startsWith(getCurrentDomain()) ? 'internal_link' : 'exit_link',
          eventName: 'technical data - link click',
        },
        attributes: {
          componentName: 'technical-data',
          label,
          targetURL,
          clickID: '',
          elementName: 'text link',
          value: '',
          pos: '',
        },
      },
    });
  }
};
